import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { PageHeader } from './PageHeader';
import { useAuth } from '../../contexts/AuthContext';

const ALL_TABS = [
  { id: 'produto', label: 'Produto', path: '/config/produto', adminOnly: false },
  { id: 'integracoes', label: 'Integrações', path: '/config/integracoes', adminOnly: true },
  { id: 'equipe', label: 'Equipe', path: '/config/equipe', adminOnly: false },
  { id: 'financeiro', label: 'Financeiro', path: '/config/financeiro', adminOnly: true },
  { id: 'sistema', label: 'Sistema', path: '/config/sistema', adminOnly: false },
] as const;

export function ConfigLayout() {
  const location = useLocation();
  const { user } = useAuth();
  const isAdmin = user?.role === 'ADMIN';

  const TABS = ALL_TABS.filter((t) => !t.adminOnly || isAdmin);

  // The active tab considers any nested path under it
  const activeId = TABS.find((t) => location.pathname.startsWith(t.path))?.id ?? 'produto';

  return (
    <div className="space-y-6">
      <PageHeader
        eyebrow="Configuração"
        title="Ajustes do CRM"
        subtitle="Produto, equipe, financeiro e sistema."
      />

      <nav className="flex gap-1 border-b border-border sticky top-0 bg-canvas/80 backdrop-blur z-10">
        {TABS.map((t) => (
          <NavLink
            key={t.id}
            to={t.path}
            className={
              t.id === activeId
                ? 'text-sm px-4 py-2 -mb-px border-b-2 border-ink-primary text-ink-primary font-medium'
                : 'text-sm px-4 py-2 -mb-px border-b-2 border-transparent text-ink-tertiary hover:text-ink-secondary'
            }
          >
            {t.label}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
